import { useState } from "react";
import PricingCard from "./PricingCard";
import SignupModal from "./SignupModal";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";

const PricingSection = () => {
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("");
  const { ref: sectionRef, isIntersecting: isVisible } =
    useIntersectionObserver();

  const handlePricingButtonClick = (plan: string) => {
    setSelectedPlan(plan);
    setShowSignupModal(true);
  };

  const pricingPlans = [
    {
      title: "Free",
      price: "Gratis",
      dummy_price: "",
      description: "30 menit catatan otomatis/bulan",
      features: [
        {
          title: "Hingga 30 menit catatan meeting otomatis per bulan",
          available: true,
        },
        { title: "Akses ke aplikasi Web", available: true },
        {
          title: "Maks. 1 sesi rapat pada satu waktu (online/tatap muka)",
          available: true,
        },
        {
          title:
            "Pencatatan menggunakan bot untuk Google Meet, Microsoft Teams, dan Zoom",
          available: true,
        },
        {
          title: "Transkripsi dan ringkasan secara real-time",
          available: true,
        },
        {
          title: "Ekspor catatan akhir, ringkasan, dan transkripsi",
          available: true,
        },
        { title: "Mulai mencatat menggunakan aplikasi web", available: true },
        { title: "Format MoM dasar", available: true },
        { title: "Ekspor PDF", available: true },
        { title: "Transkripsi Bahasa Indonesia", available: true },
        { title: "Transkripsi Bahasa Inggris", available: true },
        { title: "Prioritas transkripsi", available: false },
      ],
      buttonText: "Daftar Gratis",
      isPopular: false,
    },
    {
      title: "Starter",
      price: "Rp 100.000",
      description: "100 menit catatan otomatis/bulan",
      features: [
        {
          title: "Hingga 100 menit catatan meeting otomatis per bulan",
          available: true,
        },
        { title: "Akses ke aplikasi Web", available: true },
        {
          title: "Tidak sesi rapat pada satu waktu (online/tatap muka)",
          available: true,
        },
        {
          title:
            "Pencatatan menggunakan bot untuk Google Meet, Microsoft Teams, dan Zoom",
          available: true,
        },
        {
          title: "Transkripsi dan ringkasan secara real-time",
          available: true,
        },
        {
          title: "Ekspor catatan akhir, ringkasan, dan transkripsi",
          available: true,
        },
        { title: "Mulai mencatat menggunakan aplikasi web", available: true },
        { title: "Format MoM dasar", available: false },
        { title: "Ekspor PDF", available: true },
        { title: "Transkripsi Bahasa Indonesia", available: true },
        { title: "Transkripsi Bahasa Inggris", available: true },
        { title: "Prioritas transkripsi", available: false },
      ],
      buttonText: "Berlangganan",
      isPopular: false,
    },
    {
      title: "Business",
      price: "Rp 500.000",
      description: "500 menit catatan otomatis/bulan",
      features: [
        {
          title: "Hingga 500 menit catatan meeting otomatis per bulan",
          available: true,
        },
        { title: "Akses ke aplikasi Web", available: true },
        {
          title: "Tidak terbatas sesi rapat pada satu waktu (online/tatap muka)",
          available: true,
        },
        {
          title:
            "Pencatatan menggunakan bot untuk Google Meet, Microsoft Teams, dan Zoom",
          available: true,
        },
        {
          title: "Transkripsi dan ringkasan secara real-time",
          available: true,
        },
        {
          title: "Ekspor catatan akhir, ringkasan, dan transkripsi",
          available: true,
        },
        { title: "Mulai mencatat menggunakan aplikasi web", available: true },
        { title: "Format MoM dasar", available: false },
        { title: "Ekspor PDF", available: true },
        { title: "Transkripsi Bahasa Indonesia", available: true },
        { title: "Transkripsi Bahasa Inggris", available: true },
        { title: "Prioritas transkripsi", available: false },
      ],
      buttonText: "Berlangganan",
      isPopular: false,
    },
    {
      title: "Pro",
      price: "Rp 800.000",
      description: "1000 menit catatan otomatis/bulan",
      features: [
        {
          title: "Hingga 1000 menit catatan meeting otomatis per bulan",
          available: true,
        },
        { title: "Akses ke aplikasi Web", available: true },
        {
          title: "Tidak terbatas sesi rapat pada satu waktu (online/tatap muka)",
          available: true,
        },
        {
          title:
            "Pencatatan menggunakan bot untuk Google Meet, Microsoft Teams, dan Zoom",
          available: true,
        },
        {
          title: "Transkripsi dan ringkasan secara real-time",
          available: true,
        },
        {
          title: "Ekspor catatan akhir, ringkasan, dan transkripsi",
          available: true,
        },
        { title: "Mulai mencatat menggunakan aplikasi web", available: true },
        { title: "Format MoM dasar", available: false },
        { title: "Ekspor PDF", available: true },
        { title: "Transkripsi Bahasa Indonesia", available: true },
        { title: "Transkripsi Bahasa Inggris", available: true },
        { title: "Prioritas transkripsi", available: true },
      ],
      buttonText: "Berlangganan",
      isPopular: false,
    },
    {
      title: "Enterprise",
      price: "Hubungi Kami",
      description: "Tanpa batasan menit catatan otomatis",
      features: [
        {
          title: "Catatan meeting otomatis tanpa batasan menit per bulan",
          available: true,
        },
        { title: "Akses ke aplikasi Web", available: true },
        {
          title: "Hingga 5 sesi rapat pada satu waktu (online/tatap muka)",
          available: true,
        },
        {
          title:
            "Pencatatan menggunakan bot untuk Google Meet, Microsoft Teams, dan Zoom",
          available: true,
        },
        {
          title: "Transkripsi dan ringkasan secara real-time",
          available: true,
        },
        {
          title: "Ekspor catatan akhir, ringkasan, dan transkripsi",
          available: true,
        },
        { title: "Mulai mencatat menggunakan aplikasi web", available: true },
        { title: "Format MoM dasar", available: true },
        { title: "Ekspor PDF", available: true },
        { title: "Transkripsi Bahasa Indonesia", available: true },
        { title: "Transkripsi Bahasa Inggris", available: true },
        { title: "Prioritas transkripsi", available: true },
      ],
      buttonText: "Hubungi Sales",
      isPopular: false,
    },
  ];

  return (
    <section
      id="harga"
      className="py-20 relative overflow-hidden bg-perisalah-darkblue"
      ref={sectionRef}
    >
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-perisalah-darkblue/60 to-black z-0"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div
          className={`text-center max-w-3xl mx-auto mb-16 ${
            isVisible ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="text-gradient">Harga Terjangkau</span>
          </h2>
          <p className="text-gray-300 text-lg">
            Pilih paket yang sesuai dengan kebutuhan bisnis Anda, mulai dari
            paket gratis hingga solusi enterprise.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 max-w-7xl mx-auto">
          {pricingPlans.map((plan, index) => (
            <div
              key={index}
                className={`bg-black/30 border rounded-xl backdrop-blur-sm transition-all flex flex-col relative ${
                plan.isPopular ? "border-perisalah-purple" : "border-white/10"
              } ${
                isVisible
                  ? `animate-fade-in-up delay-${index + 1}00`
                  : "opacity-0"
              } hover:border-perisalah-purple/50 hover:bg-black/50`}
            >
              {plan.isPopular && (
                <div className="absolute -top-4 left-0 right-0 flex justify-center">
                  <span className="bg-perisalah-purple text-white text-xs font-bold px-3 py-1 rounded-full">
                    TERPOPULER
                  </span>
                </div>
              )}
              <div className="p-6 flex flex-col flex-grow">
                <div className="text-xl font-semibold text-white mb-2">
                  {plan.title}
                </div>
                <div className="mt-2 flex flex-col">
                  {plan.dummy_price && (
                    <span className="text-lg line-through text-gray-400">
                      {plan.dummy_price}
                    </span>
                  )}
                  {plan.price !== "0" && (
                    <span className="text-3xl font-bold text-white">
                      {plan.price}
                    </span>
                  )}
                </div>
                <div className="text-gray-400 mb-4">{plan.description}</div>
                <ul className="space-y-3 mb-6 flex-grow">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <span
                        className={`mr-2 ${
                          feature.available
                            ? "text-perisalah-blue"
                            : "text-gray-500"
                        }`}
                      >
                        •
                      </span>
                      <span
                        className={`text-xs ${
                          feature.available
                            ? "text-white"
                            : "text-gray-500 line-through"
                        }`}
                      >
                        {feature.title}
                      </span>
                    </li>
                  ))}
                </ul>
                <button
                  className={`w-full py-2 rounded font-bold transition-all mt-auto ${
                    plan.isPopular
                      ? "bg-perisalah-purple hover:bg-perisalah-darkerpurple text-white"
                      : "bg-white/10 hover:bg-white/20 border border-white/20 text-white"
                  }`}
                  onClick={() =>
                    (window.location.href =
                      plan.title === "Enterprise"
                        ? "https://wa.me/628112127696"
                        : "https://app.perisalah.ai/pricing")
                  }
                >
                  {plan.buttonText}
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className={"mt-16 text-center"}>
          <p className="text-gradient text-lg">
            Membutuhkan paket perusahaan dengan fitur khusus?
          </p>
          <a
            href="https://wa.me/628112127696"
            className="text-gray-300 text-lg font-bold hover:underline"
          >
            Hubungi kami untuk paket Enterprise
          </a>
        </div>
      </div>

      {showSignupModal && (
        <SignupModal
          onClose={() => setShowSignupModal(false)}
          selectedPlan={selectedPlan}
        />
      )}
    </section>
  );
};

export default PricingSection;
